export default __webpack_public_path__ + "assets/images/517-small.png";